module.exports = __webpack_public_path__ + "static/img/eagle-ji-logo.e3b9015b.png";